import React, { useEffect, useState } from 'react';
import { sendEmailVerification as firebaseSendEmailVerification } from 'firebase/auth';
import { logoutUser } from '../../../services/AuthRepository';

export const VerifyEmailScreen = ({ user }) => {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const isLocalQaHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost');

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        await user.reload();

        if (user.emailVerified) window.location.reload();
      } catch (e) {
        console.error(e);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, [user]);

  const handleResend = async () => {
    if (isLocalQaHost) {
      setSent(true);
      return;
    }
    setLoading(true);
    try {
      await firebaseSendEmailVerification(user);
      setSent(true);
    } catch (e) {
      alert('Erro: ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4 animate-fade-in-up">
      <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-yellow-500 w-full max-w-md text-center">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="fas fa-envelope text-4xl text-yellow-600"></i>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Verifique seu E-mail</h2>
        <p className="text-sm text-gray-600 mb-6 leading-relaxed">
          Para sua segurança, enviamos um link de confirmação para <strong>{user.email}</strong>.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-brand-blue text-white py-3 rounded-lg font-bold shadow hover:bg-[#1a1e30]"
          >
            JÁ CLIQUEI NO LINK
          </button>
          <button
            onClick={handleResend}
            disabled={sent || loading}
            className="w-full bg-white border border-gray-300 text-gray-600 py-3 rounded-lg font-bold hover:bg-gray-50"
          >
            {sent ? 'E-MAIL ENVIADO!' : 'REENVIAR E-MAIL'}
          </button>
          <button onClick={logoutUser} className="text-xs text-red-400 font-bold hover:text-red-600 mt-4 underline">
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};